import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';
import { Actions } from '../../actions';
import {
  UpdateMerchStatus,
  UpdateMerchStatusSuccess,
} from '../action-creators';
import { UPDATE_MERCH_STATUS } from '../actions';
import { NoOp } from '@webapp/store/ui/action-creators';
import AppState from '@webapp/store/state';

export const updateMerchStatusEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, UpdateMerchStatus>(UPDATE_MERCH_STATUS),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const artistId = state.artist.active?.id;
        if (!!artistId) {
          const updatedProduct = await merch.editMerchStatus(
            action.status,
            action.productId,
            artistId
          );
          return new UpdateMerchStatusSuccess(updatedProduct);
        }
        return new NoOp();
      } catch (err) {
        console.error('UpdateMerchStatus error:', err);
        return new NoOp();
      }
    })
  );
